import botIcon from '../../../assets/jupiter_lottie_bot.json';
import LottieIcon from '../lottie-icon';

export function AnimatedBotIcon() {
  return <LottieIcon animationData={botIcon} loop={true} />;
}
